export default __webpack_public_path__ + "static/media/meta_residence.1b0b4e56.svg";